export default function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">联系我们</h2>
        <p className="text-sm md:text-base text-foreground-500 mb-8 md:mb-10">有动漫推荐、资源反馈或合作建议？随时联系我们</p>
        <div className="rounded-2xl bg-background-100 border border-background-200/70 p-6 md:p-8">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
            <div className="flex flex-col items-center gap-2 p-4 rounded-xl hover:bg-background-50 transition-colors cursor-pointer">
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-primary-500 text-xl" style={{ width: '1em', height: '1em' }}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-900">投稿邮箱</span>
              <span className="text-xs text-foreground-500">submit@6080ys.com</span>
            </div>
            <div className="flex flex-col items-center gap-2 p-4 rounded-xl hover:bg-background-50 transition-colors cursor-pointer">
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-discuss-line text-accent-500 text-xl" style={{ width: '1em', height: '1em' }}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-900">资源反馈</span>
              <span className="text-xs text-foreground-500">feedback@6080ys.com</span>
            </div>
            <div className="flex flex-col items-center gap-2 p-4 rounded-xl hover:bg-background-50 transition-colors cursor-pointer">
              <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className="ri-briefcase-line text-secondary-500 text-xl" style={{ width: '1em', height: '1em' }}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-900">商务合作</span>
              <span className="text-xs text-foreground-500">business@6080ys.com</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}